export default {
  name: 'marking--quickPrint',
  urlParamName: 'marking--quickPrint',
};